import src from "IMAGE";
export default { src, width: 2000, height: 200, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mNg4+ITZuTgFwFhBnZeQQYuYUkGbhEpBk5BcQYOPmEAFw0BeK7Cc+4AAAAASUVORK5CYII="};
